import { useCallback, useEffect, useState } from 'react';

type PermsApiResponse = {
	permitted: boolean;
};

const getUserOrgPermissions = async (orgId: string, userId: string) => {
	const data = {
		resourceId: `ari:cloud:platform::org/${orgId}`,
		principalId: `ari:cloud:identity::user/${userId}`,
		permissionId: 'manage-users',
	};
	const response = await fetch('/gateway/api/permissions/permitted', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});

	return ((await response.json()) as unknown as PermsApiResponse).permitted;
};

export const useOrgAdminPermission = (orgId?: string | null, userId?: string | null) => {
	const [data, setData] = useState<boolean | null>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);

	const fetchIsOrgAdmin = useCallback(async () => {
		if (!userId || !orgId) {
			return false;
		}

		setError(null);
		try {
			const permitted = await getUserOrgPermissions(orgId, userId);
			setData(permitted);
		} catch (err) {
			setError(err as Error);
			setData(null);
		} finally {
			setLoading(false);
		}
	}, [orgId, userId]);

	useEffect(() => {
		if (orgId && userId) {
			fetchIsOrgAdmin();
		}
	}, [orgId, userId, fetchIsOrgAdmin]);

	return {
		isOrgAdmin: !!data,
		loading,
		hasErrorOccurred: !!error,
	};
};
